import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { PictureSources } from '../types';
import {
  closePhotosModal,
  setPhotosCollection,
  setPhotosModalSource,
  showPhoto,
  showPhotosModal,
} from '../actions';

type PhotosModalShowingActions =
  | ActionType<typeof showPhotosModal>
  | ActionType<typeof closePhotosModal>
  | ActionType<typeof showPhoto>;
const photosModalIsShowedReucer = createReducer<boolean, PhotosModalShowingActions>(false)
  .handleAction([showPhotosModal, showPhoto], () => true)
  .handleAction(closePhotosModal, () => false);

type CurrentShowedPhotosActions = ActionType<typeof showPhoto> | ActionType<typeof closePhotosModal>;
const currentShowedPhoto = createReducer<PictureSources | null, CurrentShowedPhotosActions>(null)
  .handleAction(showPhoto, (_, { payload }) => payload)
  .handleAction(closePhotosModal, () => null);

type PhotosCollectionActions = ActionType<typeof setPhotosCollection>;
const photosCollection = createReducer<PictureSources[], PhotosCollectionActions>([]).handleAction(
  setPhotosCollection,
  (_, { payload }) => payload,
);

type PhotosModalSource = 'gallery' | 'review' | null;
type PhotosModalSourceActions =
  | ActionType<typeof setPhotosModalSource>
  | ActionType<typeof closePhotosModal>;
const photosModalSource = createReducer<PhotosModalSource, PhotosModalSourceActions>(null)
  .handleAction(setPhotosModalSource, (_, { payload }) => payload)
  .handleAction(closePhotosModal, () => null);

export const photosModalReducer = combineReducers({
  isShowed: photosModalIsShowedReucer,
  currentShowed: currentShowedPhoto,
  photos: photosCollection,
  source: photosModalSource,
});
